export default __webpack_public_path__ + "static/media/Gilroy-Extrabold.f39ff81c.woff";